module.exports = __webpack_public_path__ + "img/web3.a281ca23.png";